export default function SquareBoxIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#929292"
        d="M21 1.25h-6c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h6c.97 0 1.75-.78 1.75-1.75V3c0-.97-.78-1.75-1.75-1.75ZM22.74 16.77l-3.5-3.5a1.75 1.75 0 0 0-2.47 0l-3.5 3.5a1.75 1.75 0 0 0 0 2.47l3.5 3.5a1.75 1.75 0 0 0 2.47 0l3.5-3.5a1.75 1.75 0 0 0 0-2.47ZM9 1.25H3c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h6c.97 0 1.75-.78 1.75-1.75V3c0-.97-.78-1.75-1.75-1.75ZM9 13.25H3c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h6c.97 0 1.75-.78 1.75-1.75v-6c0-.97-.78-1.75-1.75-1.75Z"
      />
    </svg>
  );
}
